import api from "./client"
import type { WorkoutLog } from "../types"

export async function getWorkoutLogs(userId?: number): Promise<WorkoutLog[]> {
  const params = userId ? { user_id: userId } : {}
  const { data } = await api.get<WorkoutLog[]>("/workout_logs", { params })
  return data
}

export async function createWorkoutLog(
  params: Record<string, unknown>,
  userId?: number,
): Promise<WorkoutLog> {
  const body: Record<string, unknown> = { workout_log: params }
  if (userId) body.user_id = userId
  const { data } = await api.post<WorkoutLog>("/workout_logs", body)
  return data
}

export async function deleteWorkoutLog(id: number): Promise<void> {
  await api.delete(`/workout_logs/${id}`)
}
